// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IChangesetChangeDto
 */
export interface IChangesetChangeDto {
    /**
     * 
     * @type {number}
     * @memberof IChangesetChangeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IChangesetChangeDto
     */
    field_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IChangesetChangeDto
     */
    old_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IChangesetChangeDto
     */
    new_value?: string;
    /**
     * 
     * @type {number}
     * @memberof IChangesetChangeDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IChangesetChangeDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IChangesetChangeDto
     */
    employee_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IChangesetChangeDto
     */
    plan_name?: string;
}

/**
 * Check if a given object implements the IChangesetChangeDto interface.
 */
export function instanceOfIChangesetChangeDto(value: object): value is IChangesetChangeDto {
    return true;
}

export function IChangesetChangeDtoFromJSON(json: any): IChangesetChangeDto {
    return IChangesetChangeDtoFromJSONTyped(json, false);
}

export function IChangesetChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IChangesetChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'field_name': json['field_name'] == null ? undefined : json['field_name'],
        'old_value': json['old_value'] == null ? undefined : json['old_value'],
        'new_value': json['new_value'] == null ? undefined : json['new_value'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
    };
}

export function IChangesetChangeDtoToJSON(json: any): IChangesetChangeDto {
    return IChangesetChangeDtoToJSONTyped(json, false);
}

export function IChangesetChangeDtoToJSONTyped(value?: IChangesetChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'field_name': value['field_name'],
        'old_value': value['old_value'],
        'new_value': value['new_value'],
        'employee_id': value['employee_id'],
        'plan_id': value['plan_id'],
        'employee_name': value['employee_name'],
        'plan_name': value['plan_name'],
    };
}

